import { SearchX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { routes } from '../../shared/routing';
import { Button, EmptyState } from '../../shared/ui';
import { AppShell } from '../../widgets/app-shell';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <AppShell page={null} crumbs={[t('notFound.title')]}>
      <EmptyState
        className="py-24"
        icon={<SearchX />}
        title={t('notFound.title')}
        body={t('notFound.body')}
        action={
          <Button
            onClick={() => {
              void routes.positions.open();
            }}
          >
            {t('notFound.back')}
          </Button>
        }
      />
    </AppShell>
  );
}
